import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "error-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: "35em",
    min_width: "20em",
    segment: "red"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString($props.title), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_2, _toDisplayString($options.errtext), 1 /* TEXT */)
    ]),
    controls: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1 /* HOISTED */)),
      _createVNode(_component_Button, {
        plain: "",
        onClick: $options.onCopyError
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Copy error ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        plain: "",
        onClick: $options.onRestart
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Restart ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1 /* HOISTED */))
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}